<ng-container *ngIf="displayText">
  <div class="mg-date-separator">
    <mg-text variant="header-md-secondary">{{ displayText }}</mg-text>
  </div>
</ng-container>
